// basic object simulating DDC.InvData Object to populate ws-inv-listing

export class InvData {
	constructor() {
		this.facets = {};
		this.inventory = {};
		this.alertMessage = {};
	}

	registerInventoryNotification = () => {};

	registerToggleListingView = () => {};

	getFacets() {
		return this.facets;
	}

	getInventory() {
		return this.inventory;
	}

	getPaging() {
		return this.inventory?.pageInfo || null;
	}
}
